import client from './client';

export const importApi = {
  /**
   * Preview CSV import - parses file and returns tasks to be imported
   * @param {string} projectKey - Project key to import into
   * @param {File} file - CSV file
   */
  async previewCsv(projectKey, file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await client.post(
      `/api/import/csv/${projectKey}/preview`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data;
  },

  /**
   * Execute CSV import - creates tasks from CSV file
   * @param {string} projectKey - Project key to import into
   * @param {File} file - CSV file
   */
  async executeCsv(projectKey, file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await client.post(
      `/api/import/csv/${projectKey}/execute`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data;
  },
};
